import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message,Progress,notification,Popover} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},
    {key:'expenseCode', label: '经费编号', width: 100},
    {key:'expenseName', label: '经费名称', width: 150 ,render: (value,row) =>
    <span> 
        <Popover placement="topLeft" style={{ width: 300 }}  content={
            <div style={{ width: 200 }}>
                {
                    row.categoryPathStr
                }
            </div>} 
            title="分类路径"
            >
            {value}
        </Popover>
    </span> 
    },
    {key:'expenseSubjectName', label: '经费科目'},
    {key:'expenseContent', label: '报销内容',render: (value,row) =>
    <span> 
        <Popover placement="topLeft" style={{ width: 300 }}  content={
            <div style={{ width: 200 }}>
                {
                    row.expenseContent
                }
            </div>} 
            title="报销内容"
            >
            {value}
        </Popover>
    </span> },
    {key:'money', label: '金额（元）', width: 100},
    {key:'usingUserName', label: '使用人'},
    {key:'submitUserName', label: '报销人'},
    {key:'expenseUsingTime', label: '经费使用时间'},
    {key:'expenseSubmitTime', label: '报销时间'},
    {key:'expenseDesc', label: '备注'},
    {key:'createDate', label: '创建时间'},
    // {key:'expenseProgress', label: '经费执行进度' ,
    //         render:(value) => <Progress percent={parseInt(value)} />  },
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('supv/expense/query?' + params.join('&'), keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta
        };
    })
    .then(res => (Object.assign({
        result: res.data.dataList || [],
        selects: (res.data.dataList || []).map(d => ({
            value: d.id,
            checked: false,
            name: d.taskName
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const querySearchById = (id) => {
    return fetch.get('supv/expense/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

const querySearchBySelectId = (id) => {
    return fetch.get('supv/budget/getBySelectId/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('/supv/expense/insert', data);
}

const insertByTask = (data) => {
    return fetch.post('/supv/expense/insertByTask', data);
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('supv/expense/update/' + id, data)
    .then(response => {
        return response;
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('supv/expense/delete', ids)
    .then(response => {
        return response;
    });
}


/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
 const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>删除成功</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.selectData = [];
                                DataGrid.refresh();
                                callback();
                            },
                        });
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'employee'+ url;
};

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

const targetAnalysisByOrg=(keywords) => {

    const defaultsParams = {
    };

    return fetch.post('supv/expense/targetanalysisbyorg', Object.assign(defaultsParams, keywords))
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta.extParams
        };
    });
}

export default {
    querySearch,
    columns,
    onSelect,
    batchRemove,
    insert,
    insertByTask,
    update,
    onSelectData,
    setRefresh,
    redirect,
    getSelection,
    getSelectionData,
    querySearchById,
    querySearchBySelectId,
    targetAnalysisByOrg
}